import script from "./private-shoutout-success.vue?vue&type=script&setup=true&lang=js"
export * from "./private-shoutout-success.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__